// Public Terms & Conditions for CLIENT INTERNAL AUDIT quotations (/terms/internal-audit).
// bizSAFE quotations keep their own /terms page unchanged.
import React from 'react'
import { FirmHeader } from '../components/PublicComponents'
import { IA_TERMS } from '../lib/iaQuote'

export default function IATermsPage() {
  return (
    <div style={{ minHeight: '100vh', background: '#f7f6f3', padding: '40px 20px 60px' }}>
      <div style={{ maxWidth: 780, margin: '0 auto' }}>
        <FirmHeader accredited={false} />
        <div style={{ marginBottom: 24 }}>
          <h1 style={{ fontWeight: 500, fontSize: 24, marginBottom: 4 }}>Terms &amp; Conditions — Third-Party Internal Audit</h1>
        </div>
        <div style={{ background: '#fff', borderRadius: 12, padding: '28px 32px', border: '0.5px solid rgba(0,0,0,0.1)', marginBottom: 20 }}>
          {IA_TERMS.map((clause, i) => (
            <div key={i} style={{ display: 'flex', gap: 12, marginBottom: 14, fontSize: 13, lineHeight: 1.7, color: '#333' }}>
              <span style={{ color: '#999', flexShrink: 0, marginTop: 1 }}>{i + 1}.</span>
              <span>{clause}</span>
            </div>
          ))}
        </div>
        <p style={{ textAlign: 'center', color: '#aaa', fontSize: 12 }}>CCIS Singapore Pte Ltd · Reg. No. 199205611D · 16 Jalan Kilang Timor #08-03, Redhill Forum Singapore 159308</p>
      </div>
    </div>
  )
}
